import SimpleBarScroll from "../../../../third-party/SimpleBar";
import Navigation from "./Navigation";

// ==============================|| DRAWER CONTENT ||============================== //

const DrawerContent = () => (
  <SimpleBarScroll
    sx={{
      "& .simplebar-content": {
        display: "flex",
        flexDirection: "column",
      },
    }}
  >
    <Navigation />
  </SimpleBarScroll>
);

export default DrawerContent;
